import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestRemotesGetRes } from "./abst/DtoRequestRemotesGetRes";

export class DtoRequestRemotesGetResImple extends DtoRequestRemotesGetRes {
  public request = new EntityRequest();

  public pager = new DtoApiPager();
}
